var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar',{attrs:{"id":_vm.id,"menu":_vm.menu,"submenu":_vm.submenu}}),_c('v-container',{attrs:{"fluid":""}},[_c('LoadData')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }